import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers/index";
import thunk from "redux-thunk";


// this line is important to check the redux data through redux dev tool.
// if we removed this redux devtool will wont work
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// passing combined reducers to store.
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

export default store;
